import {emotionStyled, tokens} from '@packages/utilities/styled';
import {Stack, VStack} from '../Stack';
import {Text} from '../Text';

import {selectors} from '../../utils';
import {Link} from '../Link';
import {Button} from '../Button';

export const IconWrapper = emotionStyled('div')(
  {
    color: '$textPrimary',
  },
  {
    componentName: 'EmptyStateIconWrapper',
  }
);

export const TitleWrapper = emotionStyled(Text)(
  {},
  {
    componentName: 'EmptyStateTitleWrapper',
  }
);

export const EmptyStateActionsView = emotionStyled(Stack)(
  {
    width: 'fit-content',
  },
  {
    componentName: 'EmptyStateActions',
    variants: {
      isFullWidth: {
        true: {
          width: '100%',
        },
      },
    },
  }
);

export const EmptyStateBodyView = emotionStyled(VStack)(
  {
    textAlign: 'center',
    gap: '$1',
  },
  {
    componentName: 'EmptyStateBody',
    variants: {
      size: {
        medium: {},
        'x-large': {
          gap: '$2',
        },
      },
      isCompact: {
        true: {
          textAlign: 'start',
          [`&:only-child`]: {
            alignItems: 'center',
            textAlign: 'center',
          },
        },
      },
    },
  }
);

export const EmptyStateView = emotionStyled(Stack)(
  {
    gap: '$1',
    borderRadius: '$2',
    backgroundColor: '$uiCardBackground',
    paddingTop: tokens.ui.emptyState.padding.top,
    paddingRight: tokens.ui.emptyState.padding.right,
    paddingBottom: tokens.ui.emptyState.padding.bottom,
    paddingLeft: tokens.ui.emptyState.padding.left,
    [selectors.disabled('&')]: {
      opacity: tokens.opacities.disabled,
    },
  },
  {
    componentName: 'EmptyState',
    variants: {
      size: {
        medium: {},
        'x-large': {
          gap: '$2',
        },
      },
      isDropTarget: {
        true: {
          borderColor: '$border3',
          borderStyle: 'dashed',
          [`&${selectors.hovered}`]: {
            backgroundColor: '$background3',
          },
        },
      },
      isTransparent: {
        true: {
          backgroundColor: 'transparent',
        },
      },
      isBranded: {
        true: {
          fontFamily: '$brandedBody',
          padding: '$6',
        },
      },
    },
  }
);

export const EmptyStateLinkView = emotionStyled(Link)({
  whiteSpace: 'pre',
  marginTop: tokens.ui.emptyState.margin.link.top,
  marginBottom: tokens.ui.emptyState.margin.link.bottom,
});

export const EmptyStateButtonView = emotionStyled(Button)({
  marginTop: tokens.ui.emptyState.margin.button.top,
  marginBottom: tokens.ui.emptyState.margin.button.bottom,
});
